import { useState } from 'react';
import api from '../services/api';

/**
 * @module useSaveMonthlyReports
 * @description Custom hook for saving edited monthly AI reports in the Mental Health Portal application.
 * Manages saving state and provides error handling.
 *
 * @requires react
 * @requires ../services/api
 */

/**
 * Hook to save monthly AI reports
 * @function useSaveMonthlyReports
 * @returns {Object} Object containing saveMonthlyReport function and isSaving state
 */
export const useBulkSaveMonthlyReports = () => {
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState(null);

  const saveMonthlyReports = async (reports) => {
    setIsSaving(true);
    setError(null);

    try {
      const payload = {
        reports: reports.map(({ id, aiReport }) => ({
          id,
          newAiReport: aiReport,
        })),
      };

      const { data } = await api.post('update-monthly-ai-reports', payload);
      return data;
    } catch (err) {
      console.error('Erro ao salvar múltiplos relatórios mensais:', err);
      setError('Erro ao salvar relatórios mensais');
      throw err;
    } finally {
      setIsSaving(false);
    }
  };

  return { saveMonthlyReports, isSaving, error };
};
